<style lang="less" scoped>
@import "./login.less";
</style>
<template>
  <div class="loginContainner">
     <el-button type="primary" @click='login'>login</el-button>
  </div>
</template>
<script>
import mix from "./login-mixins";
export default {
  mixins: [mix]
};
</script>
<style lang="less">
.loginContainner {
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue